module.exports = __webpack_public_path__ + "img/p1.136c640e.png";